import Vue from 'vue';

const state = {
  adzones: [],
  categories: [],
  advDashboardWidgets: {},
  advDashboardStats: {},
  creativeTypes: [],
  creativeFormats: [],
  pubDashboardWidgets: {},
  pubDashboardStats: {},
  advertCampaigns: [],
  advertCreatives: [],
  creatives: [],
  advertLandings: [],
  advertCreativeTags: [],
  dimensions: [],
  adFormats: [],
  adPlacements: [],
  bannerDimensions: [],
  connectionTypes: [],
  deviceTypes: [],
  deviceModels: [],
  exchangeTypes: [],
  exchanges: [],
  languages: [],
  siteCategories: [],
  trafficTypes: [],
  metrics: [],
  events: [],
  countries: [],
  regions: [],
  cities: [],
  browserNames: [],
  browserVendors: [],
  browserVersions: [],
  osFamilies: [],
  osNames: [],
  osVersions: [],
  isps: [],
  pricingModels: [],
  landingsDistribution: [
    {
      id: 0,
      name: 'even'
    },
    {
      id: 1,
      name: 'fixed'
    }
  ],
  landingGroups: []
};

const mutations = {
  MERGE_ADZONES(state, payload) {
    if (!payload) return;
    state.adzones = [...state.adzones, ...payload];
  },

  SET_ADZONES(state, payload) {
    state.adzones = payload;
  },

  SET_ADZONES_CATEGORIES(state, payload) {
    state.categories = payload;
  },

  SET_CREATIVE_TYPES(state, payload) {
    state.creativeTypes = payload;
  },

  SET_CREATIVE_FORMATS(state, payload) {
    state.creativeFormats = payload;
  },

  SET_ADV_DASHBOARD_STATS(state, payload) {
    state.advDashboardStats = payload;
  },

  SET_ADV_DASHBOARD_WIDGETS(state, payload) {
    state.advDashboardWidgets = payload;
  },

  SET_PUB_DASHBOARD_STATS(state, payload) {
    state.pubDashboardStats = payload;
  },

  SET_PUB_DASHBOARD_WIDGETS(state, payload) {
    state.pubDashboardWidgets = payload;
  },

  SET_ADVERT_CAMPAIGNS(state, payload) {
    state.advertCampaigns = payload;
  },

  SET_ADVERT_CREATIVES(state, payload) {
    state.advertCreatives = payload;
  },

  SET_CREATIVES(state, payload) {
    state.creatives = payload;
  },

  SET_ADVERT_CREATIVE_TAGS(state, payload) {
    state.advertCreativeTags = payload;
  },

  SET_ADVERT_LANDINGS(state, payload) {
    state.advertLandings = payload;
  },

  SET_LANDING_GROUPS(state, payload) {
    state.landingGroups = payload;
  },

  SET_AD_FORMATS(state, payload) {
    state.adFormats = payload;
  },

  SET_AD_PLACEMENTS(state, payload) {
    state.adPlacements = payload;
  },

  SET_BANNER_DIMENSIONS(state, payload) {
    state.bannerDimensions = payload;
  },

  SET_CONNECTION_TYPES(state, payload) {
    state.connectionTypes = payload;
  },

  SET_DEVICE_TYPES(state, payload) {
    state.deviceTypes = payload;
  },

  SET_DEVICE_MODELS(state, payload) {
    state.deviceModels = payload;
  },

  SET_EXCHANGE_TYPES(state, payload) {
    state.exchangeTypes = payload;
  },

  SET_EXCHANGES(state, payload) {
    state.exchanges = payload;
  },

  SET_LANGUAGES(state, payload) {
    state.languages = payload;
  },

  SET_SITE_CATEGORIES(state, payload) {
    state.siteCategories = payload;
  },

  SET_TRAFFIC_TYPES(state, payload) {
    state.trafficTypes = payload;
  },

  SET_METRICS(state, payload) {
    state.metrics = payload;
  },

  SET_DIMENSIONS(state, payload) {
    state.dimensions = payload;
  },

  SET_EVENTS(state, payload) {
    state.events = payload;
  },

  SET_COUNTRIES(state, payload) {
    state.countries = payload;
    console.log(state);
  },

  SET_REGIONS(state, payload) {
    state.regions = payload;
  },

  SET_CITIES(state, payload) {
    state.cities = payload;
  },

  SET_BROWSER_NAMES(state, payload) {
    state.browserNames = payload;
  },

  SET_BROWSER_VENDORS(state, payload) {
    state.browserVendors = payload;
  },

  SET_BROWSER_VERSIONS(state, payload) {
    state.browserVersions = payload;
  },

  SET_OS_FAMILIES(state, payload) {
    state.osFamilies = payload;
  },

  SET_OS_NAMES(state, payload) {
    state.osNames = payload;
  },

  SET_OS_VERSIONS(state, payload) {
    state.osVersions = payload;
  },

  SET_ISPS(state, payload) {
    state.isps = payload;
  },

  SET_PRICING_MODELS(state, payload) {
    state.pricingModels = payload;
  }
};

const getters = {
  adzones: state => state.adzones,
  adzonesCursor: state => state.adzonesCursor,
  advDashboardStats: state => state.advDashboardStats,
  advDashboardWidgets: state => state.advDashboardWidgets,
  pubDashboardStats: state => state.pubDashboardStats,
  pubDashboardWidgets: state => state.pubDashboardWidgets,
  advertCampaigns: state => state.advertCampaigns,
  advertCreatives: state => state.advertCreatives,
  creatives: state => state.creatives,
  advertLandings: state => state.advertLandings,
  advertCreativeTags: state => state.advertCreativeTags,
  advCampaignDictionaries: state => {
    return {
      countries: state.countries,
      regions: state.regions,
      cities: state.cities,
      browserNames: state.browserNames,
      browserVendors: state.browserVendors,
      browserVersions: state.browserVersions,
      osFamilies: state.osFamilies,
      osNames: state.osNames,
      osVersions: state.osVersions,
      deviceModels: state.deviceModels,
      deviceTypes: state.deviceTypes,
      languages: state.languages,
      isps: state.isps,
      adFormats: state.adFormats,
      bannerDimensions: state.bannerDimensions,
      pricingModels: state.pricingModels,
      categories: state.siteCategories,
      trafficTypes: state.trafficTypes
    };
  },
  dictionaries: state => {
    return [
      {
        name: 'Ad formats',
        key: 'adFormat',
        list: state.adFormats
      },
      {
        name: 'Ad placements',
        key: 'adPlacement',
        list: state.adPlacements
      },
      {
        name: 'Banner dimensions',
        key: 'bannerDimensions',
        list: state.bannerDimensions
      },
      {
        name: 'Connection types',
        key: 'connectionType',
        list: state.connectionTypes
      },
      {
        name: 'Device types',
        key: 'deviceType',
        list: state.deviceTypes
      },
      {
        name: 'Exchange types',
        key: 'exchangeType',
        list: state.exchangeTypes
      },
      {
        name: 'Exchanges',
        key: 'exchange',
        list: state.exchanges
      },
      {
        name: 'Languages',
        key: 'language',
        list: state.languages
      },
      {
        name: 'Site categories',
        key: 'siteCategory',
        list: state.siteCategories
      },
      {
        name: 'Traffic types',
        key: 'trafficType',
        list: state.trafficTypes
      },
      {
        name: 'Metrics',
        key: 'metric',
        list: state.metrics
      },
      {
        name: 'Events',
        key: 'event',
        list: state.events
      }
    ].filter(el => el.list.length !== 0);
  },
  dimensions: state => state.dimensions,
  metrics: state => state.metrics,
  landingsDistribution: state => state.landingsDistribution,
  landingGroups: state => state.landingGroups,
  getLandingDistributionById: (state, getters) => id => {
    return state.landingsDistribution.find(algorithm => algorithm.id === id);
  }
};

let cancelStatisticFetching;

const actions = {
  fetchAdzones({ commit }, params) {
    // { limit = 10, cursor }
    return Vue.api.adnet
      .get('/v0/sites-and-adzones', {
        params
      })
      .then(res => {
        commit('MERGE_ADZONES', res.data);
        return res;
      });
  },
  fetchPubSites(store, { id }) {
    return Vue.api.adnet.get(`/v0/pub-sites/${id}`);
  },
  fetchAdzonesCategories({ commit }) {
    return Vue.api.adnet.get('/v0/adzone-categories').then(({ data }) => {
      commit('SET_ADZONES_CATEGORIES', data);
      return data;
    });
  },
  fetchCreativeTypes({ commit }) {
    return Vue.api.adnet.get('/v0/creative-types').then(({ data }) => {
      commit('SET_CREATIVE_TYPES', data);
      return data;
    });
  },
  fetchCreativeFormats({ commit }) {
    return Vue.api.adnet.get('/v0/creative-formats').then(({ data }) => {
      commit('SET_CREATIVE_FORMATS', data);
      return data;
    });
  },
  fetchAdvDashboardStats({ commit }) {
    return Vue.api.adnet.get('/v0/adv-dashboard-stats').then(res => {
      commit('SET_ADV_DASHBOARD_STATS', res);
      return res;
    });
  },
  fetchAdvDashboardWidgets({ commit }) {
    return Vue.api.adnet.get('/v0/adv-dashboard-widgets').then(res => {
      commit('SET_ADV_DASHBOARD_WIDGETS', res);
      return res;
    });
  },
  fetchPubDashboardWidgets({ commit }) {
    return Vue.api.adnet.get('/v0/pub-dashboard-widgets').then(res => {
      commit('SET_PUB_DASHBOARD_WIDGETS', res);
      return res;
    });
  },
  fetchInvoice() {
    return Vue.api.adnet.get('/v0/invoice').then(res => {
      return res;
    });
  },
  fetchAdvertCampaigns({ commit }, userId) {
    return Vue.api.adnet.get(`/v0/advert-campaigns/${userId}`).then(res => {
      commit('SET_ADVERT_CAMPAIGNS', res.data);
      return res;
    });
  },
  fetchAdvertCreatives({ commit }, params) {
    return Vue.api.adnet.get(`/dsp/creatives`, { params }).then(res => {
      commit('SET_ADVERT_CREATIVES', res.data);
      return res;
    });
  },
  fetchCreatives({ commit }) {
    return Vue.api.adnet.get('/dsp/creatives').then(res => {
      commit('SET_CREATIVES', res.data);
      return res;
    });
  },
  fetchAdvertCreativeTags({ commit }, userId) {
    return Vue.api.adnet.get(`/v0/advert-creative-tags/${userId}`).then(res => {
      commit('SET_ADVERT_CREATIVE_TAGS', res.data);
      return res.data;
    });
  },
  fetchLandingGroups({ commit }, params = {}) {
    return Vue.api.adnet.get('/dsp/landing-groups', { params }).then(res => {
      commit('SET_LANDING_GROUPS', res.data);
      return res;
    });
  },
  fetchAdvertLandings({ commit }, userId) {
    return Vue.api.adnet.get(`/v0/advert-landings/${userId}`).then(res => {
      commit('SET_ADVERT_LANDINGS', res.data);
      return res;
    });
  },
  fetchAdFormats({ commit }) {
    return Vue.api.adnet.get('/v0/ad-formats').then(res => {
      commit('SET_AD_FORMATS', res.adFormats);
      return res.adFormats;
    });
  },
  fetchAdPlacements({ commit }) {
    return Vue.api.adnet.get('/ad-placements').then(res => {
      commit('SET_AD_PLACEMENTS', res.adPlacements);
    });
  },
  fetchBannerDimensions({ commit }) {
    return Vue.api.adnet.get('/banner-dimensions').then(res => {
      commit('SET_BANNER_DIMENSIONS', res.bannerDimensions);
    });
  },
  fetchConnectionTypes({ commit }) {
    return Vue.api.adnet.get('/connection-types').then(res => {
      commit('SET_CONNECTION_TYPES', res.connectionTypes);
    });
  },
  // fetchDeviceTypes({ commit }) {
  //   return Vue.api.adnet.get('/device-types').then(res => {
  //     commit('SET_DEVICE_TYPES', res.deviceTypes);
  //   });
  // },
  fetchExchangeTypes({ commit }) {
    return Vue.api.adnet.get('/exchange-types').then(res => {
      commit('SET_EXCHANGE_TYPES', res.exchangeTypes);
    });
  },
  fetchExchanges({ commit }) {
    return Vue.api.adnet.get('/exchanges').then(res => {
      commit('SET_EXCHANGES', res.exchanges);
    });
  },
  fetchLanguages({ commit }) {
    return Vue.api.adnet.get('/languages').then(res => {
      commit('SET_LANGUAGES', res.languages);
    });
  },
  fetchSiteCategories({ commit }) {
    return Vue.api.adnet.get('/site-categories').then(res => {
      commit('SET_SITE_CATEGORIES', res.siteCategories);
    });
  },
  fetchTrafficTypes({ commit }) {
    return Vue.api.adnet.get('/traffic-types').then(res => {
      commit('SET_TRAFFIC_TYPES', res.trafficTypes);
    });
  },
  fetchMetrics({ commit }) {
    return Vue.api.adnet.get('/stats/metrics').then(res => {
      commit('SET_METRICS', res.metrics);
    });
  },
  fetchDimensions({ commit }) {
    return Vue.api.adnet.get('/stats/dimensions').then(res => {
      commit('SET_DIMENSIONS', res.dimensions);
    });
  },
  fetchEvents({ commit }) {
    return Vue.api.adnet.get('/stats/events').then(res => {
      commit('SET_EVENTS', res.events);
    });
  },
  fetchCountries({ commit }) {
    return Vue.api.adnet.get('/geo/countries').then(res => {
      commit('SET_COUNTRIES', res.countries);
    });
  },
  fetchRegions({ commit }) {
    return Vue.api.adnet.get('/geo/regions').then(res => {
      commit('SET_REGIONS', res.regions);
    });
  },
  fetchCities({ commit }) {
    return Vue.api.adnet.get('/geo/cities').then(res => {
      commit('SET_CITIES', res.cities);
    });
  },
  fetchBrowserVendors({ commit }) {
    return Vue.api.adnet.get('/device/browser/vendors').then(res => {
      commit('SET_BROWSER_VENDORS', res.browserVendors);
    });
  },
  fetchBrowserVersions({ commit }) {
    return Vue.api.adnet.get('/device/browser/versions').then(res => {
      commit('SET_BROWSER_VERSIONS', res.browserVersions);
    });
  },
  fetchBrowserNames({ commit }) {
    return Vue.api.adnet.get('/device/browser/names').then(res => {
      commit('SET_BROWSER_NAMES', res.browserNames);
    });
  },
  fetchOSFamilies({ commit }) {
    return Vue.api.adnet.get('/device/os/families').then(res => {
      commit('SET_OS_FAMILIES', res.osFamilies);
    });
  },
  fetchOSNames({ commit }) {
    return Vue.api.adnet.get('/device/os/names').then(res => {
      commit('SET_OS_NAMES', res.osNames);
    });
  },
  fetchOSVersions({ commit }) {
    return Vue.api.adnet.get('/device/os/versions').then(res => {
      commit('SET_OS_VERSIONS', res.osVersions);
    });
  },
  fetchDeviceTypes({ commit }) {
    return Vue.api.adnet.get('/device/types').then(res => {
      commit('SET_DEVICE_TYPES', res.deviceTypes);
    });
  },
  fetchDeviceModels({ commit }) {
    return Vue.api.adnet.get('/device/models').then(res => {
      commit('SET_DEVICE_MODELS', res.deviceModels);
    });
  },
  fetchISPs({ commit }) {
    return Vue.api.adnet.get('/isps').then(res => {
      commit('SET_ISPS', res.isps);
    });
  },
  fetchPricingModels({ commit }) {
    return Vue.api.adnet.get('/pricing-models').then(res => {
      commit('SET_PRICING_MODELS', res.pricingModels);
    });
  },
  async fetchAllDictionaries(arg) {
    return Promise.all([
      actions.fetchAdFormats(arg),
      actions.fetchAdPlacements(arg),
      actions.fetchBannerDimensions(arg),
      actions.fetchConnectionTypes(arg),
      actions.fetchDeviceTypes(arg),
      actions.fetchExchangeTypes(arg),
      actions.fetchExchanges(arg),
      actions.fetchDeviceModels(arg),
      actions.fetchLanguages(arg),
      actions.fetchCountries(arg),
      actions.fetchRegions(arg),
      actions.fetchCities(arg),
      actions.fetchBrowserNames(arg),
      actions.fetchBrowserVendors(arg),
      actions.fetchBrowserVersions(arg),
      actions.fetchOSNames(arg),
      actions.fetchOSFamilies(arg),
      actions.fetchOSVersions(arg),
      actions.fetchISPs(arg),
      actions.fetchPricingModels(arg),
      actions.fetchMetrics(arg),
      actions.fetchDimensions(arg),
      actions.fetchSiteCategories(arg),
      actions.fetchEvents(arg),
      actions.fetchTrafficTypes(arg)
    ]);
  },
  fetchStatistics(arg, params) {
    if (typeof cancelStatisticFetching === 'function') {
      cancelStatisticFetching();
    }

    return Vue.api.adnet
      .get('/stats/grouped', {
        params: {
          q: params.q
        },
        cancelToken: new Vue.api.client.CancelToken(function executor(c) {
          cancelStatisticFetching = c;
        })
      })
      .then(res => {
        const data = res.stats.map(el => {
          return {
            ...el.dimensions,
            ...el.metrics
          };
        });
        data.forEach(el => {
          params.q.groups.forEach(group => {
            if (el[group] === undefined) el[group] = 'None';
          });
          return el;
        });
        return data || [];
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
